<template>
  <div>
    <div
      style="display: inline;"
      v-html="displayText"
    />
    <div
      v-if="text.length > maxChars"
      class="ml-3"
      style="display: inline;"
    >
      <!--      Note: click.stop is needed to prevent event propagation in the parent component-->
      <span
        v-if="!isShowingMoreText"
        @click.stop="isShowingMoreText = true"
        class="text--primary font-weight-bold"
        style="cursor: pointer"
      >
        {{ showMoreLabel }}
      </span>
      <span
        v-if="isShowingMoreText"
        @click.stop="isShowingMoreText = false"
        class="text--primary font-weight-bold"
        style="cursor: pointer"
      >
        {{ showLessLabel }}
      </span>
    </div>
  </div>
</template>

<script>
const ShowMore = {
  name: "ShowMore",
  props: {
    showMoreLabel: {
      type: String,
      default: "show more"
    },
    showLessLabel: {
      type: String,
      default: "show less"
    },
    text: {
      type: String,
      required: true
    },
    maxChars: {
      type: Number,
      default: 500
    }
  },
  data: function () {
    return {
      isShowingMoreText: false
    };
  },
  computed: {
    displayText: function () {
      let originalText = this.text;
      if (!this.isShowingMoreText && this.text.length > this.maxChars) {
        originalText = `${originalText.substring(0, this.maxChars)}...`;
      }

      return originalText;
    }
  },
}

export default ShowMore;
</script>

<style scoped>

</style>
